import workerSelect from "./workerSelect";
import createAccount from "./createAccount";
import dynamicMap from "./dynamicMap";
import fieldPolygonMap from "./fieldPolygonMap";
import fieldPolygonMapStatic from "./fieldPolygonMapStatic";
import placesAutocomplete from "./placesAutocomplete";
import sectionHeading from "./sectionHeading";
import infoBlock from "./infoBlock";
import information from "./information";
import takeProfilePicture from "./takeProfilePicture";
import qrCodeGenerator from "./qrCodeGenerator";
import newFeatureTag from "./newFeatureTag";
import engagementModal from "./reviewModal";
import selectedObjectsList from "./selectedObjectsList";
import transcriptionInput from "./transcriptionInput";
import forbidden from "./forbidden";
import sdsLookup from "./sdsLookup";
import crossSellCallOut from "./crossSellCallOut";
import signature from "./signature";
import cfVideo from "./cfVideo";
import employeeSelectionBuilder from "./employeeSelectionBuilder";
import badgeScanner from "./badgeScanner";
export default [
    dynamicMap,
    fieldPolygonMap,
    fieldPolygonMapStatic,
    workerSelect,
    createAccount,
    placesAutocomplete,
    sectionHeading,
    infoBlock,
    information,
    takeProfilePicture,
    qrCodeGenerator,
    newFeatureTag,
    engagementModal,
    selectedObjectsList,
    transcriptionInput,
    forbidden,
    sdsLookup,
    crossSellCallOut,
    signature,
    cfVideo,
    employeeSelectionBuilder,
    badgeScanner,
];
